/**
 * Configuração centralizada da API
 * Este arquivo exporta a URL base da API e outras configurações relacionadas
 */

// Define a URL base da API a partir da variável de ambiente ou do host atual
const getDefaultApiUrl = () => {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    // Em produção, usar o mesmo host do frontend com prefixo /api (Ingress/Proxy faz o roteamento)
    return `${window.location.origin.replace(/\/$/, '')}/api`;
  }
  // Fallback para ambientes sem window (tests/build) ou execução local sem env
  return 'http://localhost:3000/api';
};

export const API_URL = process.env.REACT_APP_API_URL || getDefaultApiUrl();

// Exporta configurações adicionais para requisições
export const API_CONFIG = {
  timeout: 15000, // 15 segundos
  headers: {
    'Content-Type': 'application/json',
  }
}; 